<div [@routerTransition]>
  <app-page-header [heading]="'User Management'" [icon]="'fa-user'"></app-page-header>
  <form class="page-panel" role="form">
    <fieldset *ngIf="user_rights.ADD == '1'" class="form-group ">
      <div class="row">
        <div class="col-md-12">
          <div *ngIf="success_message != ''" [innerHTML]="success_message" class="alert alert-success"></div>
          <div *ngIf="error_message != ''" [innerHTML]="error_message" class="alert alert-danger"></div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-3" for="date">First Name : </label>
            <div class="col-9">
              <input [(ngModel)]="formData.firstname" class="form-control" name="f_name" placeholder="Enter first name"
                     type="text"/>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-3" for="date">Last Name : </label>
            <div class="col-9">
              <input [(ngModel)]="formData.lastname" class="form-control" name="l_name" placeholder="Enter last name"
                     type="text"/>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-3" for="date">Email : </label>
            <div class="col-9">
              <input [(ngModel)]="formData.email" class="form-control" name="email" placeholder="Enter email"
                     type="email"/>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-3" for="date">User Group : </label>
            <div class="col-9">
              <select [(ngModel)]="formData.useraccesstype"
                      class="form-control  custom-select custom-select-sm" id="sel_user_group"
                      name="sel_user_group">
                <option value="">Select User Group</option>
                <option *ngFor="let gr of user_groups"
                        value="{{ gr.USER_ACCESS_GROUP_ID }}">{{ gr.USER_ACCESS_GROUP_NAME }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-3" for="date">User Name : </label>
            <div class="col-9">
              <input [(ngModel)]="formData.username" class="form-control" name="u_name" placeholder="Enter user name"
                     type="text"/>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-3" for="date">Password : </label>
            <div class="col-9">
              <input [(ngModel)]="formData.password" class="form-control" name="u_pass" placeholder="Enter Password"
                     type="password"/>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-3" for="date">Status : </label>
            <div class="col-9">
              <label class="radio-inline">
                <input [(ngModel)]="formData.status" [checked]="formData.status == 1" id="u_stat_1" name="u_stat"
                       type="radio"
                       value="1">&nbsp;&nbsp;Enable &nbsp;&nbsp;
              </label>
              <label class="radio-inline">
                <input [(ngModel)]="formData.status" [checked]="formData.status == 0" id="u_stat_0" name="u_stat"
                       type="radio"
                       value="0">&nbsp;&nbsp;Disable
              </label>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="col-md-6">
          <button (click)="updateUserData()" class="btn btn-sm btn-info pull-right">Submit</button>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="clearfix"></div>

    </fieldset>
    <fieldset *ngIf="user_rights.ADD == '1'" class="form-group ">
      <legend>User List</legend>
      <div class="row">
        <div class="col-12">
          <table class="table table-bordered table-stripped">
            <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>User Name</th>
              <th>Email</th>
              <th>Access Group</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let user of userlist; " [class.text-muted]="user.STATUS  != '1'">
              <td>{{ user.FIRSTNAME }}</td>
              <td>{{ user.LASTNAME }}</td>
              <td>{{ user.USERNAME }}</td>
              <td>{{ user.EMAIL }}</td>
              <td>{{ user.USER_ACCESS_GROUP_NAME }}</td>
              <td>
                <button (click)="editUser(user)" *ngIf="user_rights.EDIT == '1'" alt="Edit"
                        class="btn btn-small btn-link"
                        title="Edit"><i class="fa fa-edit"></i></button>
                <button *ngIf="user_rights.DELETE == '2'" alt="Delete" class="btn btn-small btn-link" title="Delete"><i
                  class="fa fa-times"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </fieldset>
  </form>
</div>
